import * as type from '../actions/types';

const initialState = {
  restaurant: {},
  id: '',
  restaurantFetching: true,
  fetching: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.SET_ACTIVE_RESTAURANT_ID:
      return {
        ...state,
        id: action.payload,
        fetching: true,
      };

    case type.SET_ACTIVE_RESTAURANT:
      return {
        ...state,
        restaurant: action.payload,
        restaurantFetching: false,
        fetching: false,
      };

    case type.FETCH_RESTAURANT_FAILURE:
      return {
        ...state,
        restaurantFetching: false,
      };

    case type.OBEE_ONBOARD_SUCCESS: {
      const { obeeGoLiveDate, premium } = action.payload;
      return {
        ...state,
        restaurant: { ...state.restaurant, obeeGoLiveDate, premium },
      };
    }

    // case type.CLOSE_RESTAURANT_SUCCESS:
    // case type.REOPEN_RESTAURANT_SUCCESS: {
    //   const today = moment().startOf('day');
    //   const closedEarlyToday =
    //     (action.payload.data?.closures || []).filter((closure) =>
    //       today.isBetween(moment(closure.startDate), moment(closure.endDate), 'day', '[]'),
    //     )?.length > 0;
    //
    //   return {
    //     ...state,
    //     restaurant: {
    //       ...state.restaurant,
    //       closures: action.payload.data?.closures,
    //       closedEarlyToday,
    //     },
    //   };
    // }

    default:
      return state;
  }
};
